import React, { useEffect } from "react";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { AlertTriangle, Mail, Shield } from "lucide-react";
import { useAuth } from "../lib/auth";
import { FEE_DEFAULT } from "../lib/appDefaults";

export default function RefundPolicy() {
  const { config } = useAuth();
  const fee = config?.entry_fee ?? FEE_DEFAULT;
  const preLaunch = config?.status === "pre_launch";
  const entryFee = preLaunch ? "the registration fee announced when registration opens" : <span className="text-white">₹{fee} per person</span>;
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="App" data-testid="refund-page">
      <Navbar />

      <section className="relative grid-bg border-b border-white/10">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-8 lg:px-12 py-16 sm:py-20">
          <div className="label-eyebrow mb-4">
            Last updated: 19 July 2026 · Effective 2026
          </div>
          <h1 className="font-display text-5xl sm:text-7xl text-white leading-[0.95]" data-testid="refund-title">
            Cancellation &amp; Refund Policy
          </h1>
          <p className="mt-6 text-gray-400 max-w-2xl text-base sm:text-lg leading-relaxed">
            Please read this before you pay. The IdeaThon registration fee is strictly non-refundable.
          </p>
        </div>
      </section>

      <section className="bg-[#080C18]">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-8 lg:px-12 py-14 max-w-3xl">
          <div className="card-surface border-l-2 border-brand flex items-start gap-3 mb-10" data-testid="refund-banner">
            <AlertTriangle className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" strokeWidth={2} />
            <p className="text-sm text-gray-300 leading-relaxed">
              <span className="text-white font-semibold">Important:</span> The registration fee is <span className="text-brand">non-refundable under any circumstance</span>. Please be certain before paying.
            </p>
          </div>

          <div className="text-gray-400 leading-relaxed space-y-4 text-[15px]">
            <p>The IdeaThon registration fee is {entryFee} and is <span className="text-brand">strictly non-refundable under any circumstances</span>. This includes, without limitation: voluntary withdrawal from the competition; disqualification for any reason; a team falling below the minimum required size; inability to submit before any deadline; and any technical, personal, or third-party issue.</p>
            <p>Registrations cannot be cancelled once payment is completed. In the case of a duplicate charge or a genuine billing error, email <a href="mailto:info@noobsync.com" className="text-brand hover:underline">info@noobsync.com</a> from your registered email address and we will review it.</p>
            <p>These terms are governed by the laws of India; any disputes are subject to the exclusive jurisdiction of the courts in Andhra Pradesh, India.</p>
          </div>

          <div className="card-surface flex items-start gap-3 mt-12" data-testid="refund-contact">
            <Shield className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" strokeWidth={2} />
            <div className="text-sm">
              <div className="text-white font-semibold mb-1">Billing question?</div>
              <p className="text-gray-400">
                Reach out at{" "}
                <a href="mailto:info@noobsync.com" className="text-brand hover:underline inline-flex items-center gap-1">
                  <Mail className="w-3.5 h-3.5" /> info@noobsync.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
